
export const styles = {
  container: {
    backgroundColor: 'bg-pink-50',
    border: 'border-2 border-pink-400 border-dashed',
    shadow: 'shadow-xl',
    animation: 'bounce 1s ease-in-out',
    position: 'relative',
    overflow: 'visible'
  },
  header: {
    background: 'bg-gradient-to-r from-pink-400 to-pink-500',
    textColor: 'text-white font-comic',
    border: 'border-b-4 border-pink-600',
    animation: 'bounce-in 0.5s ease-out'
  },
  avatar: {
    background: 'bg-white',
    text: 'text-pink-500',
    border: 'border-4 border-pink-400',
    animation: 'cartoon-bounce 2s infinite ease-in-out',
    transform: 'rotate(-5deg)',
    shape: 'rounded-full aspect-square overflow-hidden'
  },
  messages: {
    bot: {
      background: 'bg-white',
      text: 'text-gray-800 font-comic',
      shadow: 'shadow-lg',
      border: 'border-2 border-pink-300',
      animation: 'pop-in 0.5s forwards',
      transform: 'rotate(-1deg)'
    },
    user: {
      background: 'bg-pink-400',
      text: 'text-white font-comic',
      shadow: 'shadow-lg',
      border: 'border-2 border-pink-500',
      animation: 'pop-in 0.5s forwards',
      transform: 'rotate(1deg)'
    }
  },
  typingIndicator: {
    background: 'bg-white',
    dot: 'bg-pink-400',
    border: 'border-2 border-pink-300',
    animation: 'cartoon-bounce-container 1s infinite',
    dotAnimation: 'bounce-dot 1s infinite'
  },
  input: {
    background: 'bg-white',
    text: 'text-gray-800 font-comic',
    placeholder: 'text-pink-300',
    border: 'border-2 border-pink-300 focus:border-pink-500',
    transition: 'all 0.3s ease',
    button: {
      background: 'bg-pink-400 hover:bg-pink-500',
      text: 'text-white',
      animation: 'wiggle 5s infinite ease-in-out',
      hover: {
        transform: 'scale(1.1) rotate(5deg)',
        shadow: 'shadow-lg'
      }
    }
  },
  animations: {
    '@keyframes cartoon-bounce': {
      '0%, 100%': {
        transform: 'translateY(0) rotate(-5deg)'
      },
      '50%': {
        transform: 'translateY(-10px) rotate(-5deg)'
      }
    },
    '@keyframes pop-in': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0
      },
      '70%': {
        transform: 'scale(1.1)',
        opacity: 0.7
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 1
      }
    },
    '@keyframes bounce-dot': {
      '0%, 80%, 100%': {
        transform: 'translateY(0)'
      },
      '40%': {
        transform: 'translateY(-10px)'
      }
    },
    '@keyframes wiggle': {
      '0%, 100%': {
        transform: 'rotate(0deg)'
      },
      '25%': {
        transform: 'rotate(10deg)'
      },
      '75%': {
        transform: 'rotate(-10deg)'
      }
    },
    '@keyframes float-balloon': {
      '0%': {
        transform: 'translateY(100%)',
        opacity: 0
      },
      '10%': {
        opacity: 0.7
      },
      '90%': {
        opacity: 0.7
      },
      '100%': {
        transform: 'translateY(-500%)',
        opacity: 0
      }
    }
  },
  decorations: {
    balloon: {
      width: '20px',
      height: '20px',
      borderRadius: '50%',
      background: 'bg-pink-400',
      opacity: 0.7,
      animation: 'float-balloon 5s ease-in-out infinite'
    },
    shinchan: {
      position: 'absolute',
      right: '50px',
      top: '-85px',
      transform: 'scale(0.25)',
      transformOrigin: 'bottom right',
      zIndex: 10,
      pointerEvents: 'none'
    }
  }
}; 